import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons';
import { StartInPlatziForm } from '../';
import { Actions } from './Actions';
import { AdminButton } from './AdminButton';
import styles from './Header.module.sass';

export const Header = () => {
  const headerInfo = useSelector((state) => state.get('route').get('hero'))?.toJS() || {};
  const isLogged = useSelector((state) => state.get('header')).get('isLogged') || false;
  const isProfessional = useSelector((state) => state.get('route').get('is_professional')) || false;
  const { t } = useTranslation();

  return (
    <div className={styles.Header}>
      <div className={styles.Title}>
        <span>
          {t('route.header.label')}
          {isProfessional && <FontAwesomeIcon icon={faBadgeCheck} />}
        </span>
        <h1>{headerInfo.title}</h1>
        <p>{headerInfo.description}</p>
      </div>
      <div>
        {isLogged ?
          <Actions socialNetworkTitle={headerInfo.title} /> :
          <a href="/precios/" className={styles.BuyButton} data-trans="route.selectPlan.buyText">
            {t('route.selectPlan.buyText')}
          </a>}
        <AdminButton />
      </div>
    </div>
  );
};
